import { createContext } from "react";

export const Location = createContext(null)

